module.exports = __webpack_public_path__ + "img/entreprise.1d78ced3.jpg";